import { faCopy } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LabraToolTipV2 } from '@labrav/react-components'
import { useState } from 'react'
import { useStyles } from './AuthorizationDetails.styles'

export const TextWithCopy = ({ text }: { text?: string }) => {
  const { classes } = useStyles()
  const [copied, setCopied] = useState(false)
  const handleCopy = () => {
    navigator.clipboard
      .writeText(text || '')
      .then(() => {
        setCopied(true)
        setTimeout(() => {
          setCopied(false)
        }, 2000)
      })
      .catch(error => {
        console.error('Error copying URL to clipboard:', error)
      })
  }
  return text ? (
    <div className={classes.textWithCopy}>
      {text}
      <LabraToolTipV2
        tooltipPlacement="top"
        label={`${copied ? 'Copied' : ''}`}
      >
        <FontAwesomeIcon
          icon={faCopy}
          onClick={handleCopy}
          style={{
            width: '20px',
            marginBottom: '2px',
            color: copied ? 'green' : '#6A777A',
            height: '13px',
            cursor: 'pointer',
          }}
        />
      </LabraToolTipV2>
    </div>
  ) : (
    '-'
  )
}
